import { NavLink } from 'react-router-dom';
import { SidebarElement } from '@toqio/toqio-web-components';
import styled from 'styled-components';

export const StyledSidebarItem = styled.div`
  .toqio-sidebar-item {
    &:hover {
      text-decoration: none;
    }
  }
  .toqio-sidebar-plugin-item {
    .toqio-icon:not(.toqio-custom-icon) {
      display: none;
    }
    &:hover {
      text-decoration: none;
    }
  }
 `;

// Regular Sidebar item
export const SidebarItem = ( { isSelected, to, text, iconPath, icon, onClickItem } : any) => {
  return (
    <StyledSidebarItem>
      <NavLink to={to} className={iconPath ? 'toqio-sidebar-plugin-item' : 'toqio-sidebar-item'}>
        <SidebarElement onClick={onClickItem} isSelected={isSelected} icon={icon ?? icon}>
          {!!iconPath &&
            <IconWithPath size="20" iconPath={iconPath} className="toqio-icon toqio-custom-icon" />
          }
          {text}
        </SidebarElement>
      </NavLink>
    </StyledSidebarItem>
  )
}

// Icon rendered based on a path
const IconWithPath = ({ size = 24, iconPath, className, ...props }: any) => {
  return (
    <svg {...props} width={size} height={size} viewBox="0 0 1024 1024" className={className}>
      <path d={iconPath}></path>
    </svg>
  );
}